import React from 'react';
import { Menu } from 'antd';

import { Icon } from '..';

import style from './DropDownMenu.module.scss';


export const DropDownMenu = ({ items }) => (
  <Menu className={ style.wrapper } onClick={ item => item.onClick }>
    {items.map(item => !item.hidden && (
      <Menu.Item data-testid={ item.key } key={ item.key } className={ style.item } onClick={ item.onClick } disabled={ item.disabled }>
        <div>
          <Icon vendorClass={ style.icon } svgProps={{ width: '18', height: '18' }} svg={ item.svg ?? 'appstore' } />
          {item.content}
        </div>
      </Menu.Item>
))}
  </Menu>
);
